import React from "react";
import "./Contact.css";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaFacebook,
  FaInstagram,
} from "react-icons/fa";

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero */}
      <div className="contact-hero">
        <h1 className="contact-hero-title">Contactez-nous</h1>
        <p className="contact-hero-sub">
          Une question ? Retrouvez-nous sur place ou écrivez-nous.
        </p>
      </div>

      {/* Body */}
      <div className="contact-body">

        {/* Info panel */}
        <div className="contact-info">
          <h2 className="contact-info-heading">Nous trouver</h2>

          <div className="contact-info-row">
            <FaMapMarkerAlt className="contact-info-icon" />
            <div>
              <span className="contact-info-label">Adresse</span>
              <span className="contact-info-value">
                Route Sidi Mansour km 6, Sfax
              </span>
            </div>
          </div>

          <div className="contact-info-row">
            <FaPhone className="contact-info-icon" />
            <div>
              <span className="contact-info-label">Téléphone</span>
              <a href="tel:+21658444440" className="contact-info-value contact-info-link">
                58 444 440
              </a>
            </div>
          </div>

          <div className="contact-social-row">
            <a
              href="https://www.facebook.com/profile.php?id=61559890747854"
              target="_blank"
              rel="noreferrer"
              className="contact-social-btn"
              aria-label="Facebook"
            >
              <FaFacebook />
              <span>Facebook</span>
            </a>
            <a
              href="https://www.instagram.com/casa_del_padel"
              target="_blank"
              rel="noreferrer"
              className="contact-social-btn"
              aria-label="Instagram"
            >
              <FaInstagram />
              <span>Instagram</span>
            </a>
          </div>
        </div>

        {/* Form panel */}
        <div className="contact-form-panel">
          <h2 className="contact-form-heading">Envoyer un message</h2>
          <form className="contact-form">
            <input
              type="text"
              className="contact-input"
              placeholder="Votre nom"
            />
            <input
              type="email"
              className="contact-input"
              placeholder="Votre adresse e-mail"
            />
            <input
              type="text"
              className="contact-input"
              placeholder="Sujet"
            />
            <textarea
              className="contact-input contact-textarea"
              rows="5"
              placeholder="Votre message..."
            />
            <button type="submit" className="contact-submit">
              Envoyer
            </button>
          </form>
        </div>

      </div>

    </div>
  );
};

export default Contact;
